/**
 * 意见反馈 - 常量定义
 *
 * @description 反馈类型和状态的标签、颜色映射
 * @module types/feedback/constants
 * @author AI Assistant
 * @version 1.0.0
 * @since 2026-01-21
 *
 * 对应后端文件：
 * - Model: backend/app/Modules/Feedback/Models/Feedback.php ($typeMap, $statusMap)
 */

import { FeedbackStatus, FeedbackType } from './enums'

/**
 * 反馈类型标签映射
 */
export const FEEDBACK_TYPE_LABELS: Record<FeedbackType, string> = {
  [FeedbackType.Bug]: '问题反馈',
  [FeedbackType.Suggestion]: '建议',
  [FeedbackType.Feature]: '功能需求',
  [FeedbackType.Other]: '其他',
}

/**
 * 反馈类型选项（用于下拉选择）
 */
export const FEEDBACK_TYPE_OPTIONS = Object.entries(FEEDBACK_TYPE_LABELS).map(
  ([value, label]) => ({
    value: value as FeedbackType,
    label,
  }),
)

/**
 * 反馈类型颜色映射（用于 Tag 组件）
 */
export const FEEDBACK_TYPE_COLORS: Record<FeedbackType, string> = {
  [FeedbackType.Bug]: 'red',
  [FeedbackType.Suggestion]: 'blue',
  [FeedbackType.Feature]: 'purple',
  [FeedbackType.Other]: 'default',
}

/**
 * 反馈状态标签映射
 */
export const FEEDBACK_STATUS_LABELS: Record<FeedbackStatus, string> = {
  [FeedbackStatus.Pending]: '待处理',
  [FeedbackStatus.Processing]: '处理中',
  [FeedbackStatus.Replied]: '已回复',
  [FeedbackStatus.Resolved]: '已解决',
  [FeedbackStatus.Closed]: '已关闭',
}

/**
 * 反馈状态选项（用于下拉选择）
 */
export const FEEDBACK_STATUS_OPTIONS = Object.entries(FEEDBACK_STATUS_LABELS).map(
  ([value, label]) => ({
    value: value as FeedbackStatus,
    label,
  }),
)

/**
 * 反馈状态颜色映射（用于 Tag 组件）
 */
export const FEEDBACK_STATUS_COLORS: Record<FeedbackStatus, string> = {
  [FeedbackStatus.Pending]: 'orange',
  [FeedbackStatus.Processing]: 'blue',
  [FeedbackStatus.Replied]: 'cyan',
  [FeedbackStatus.Resolved]: 'green',
  [FeedbackStatus.Closed]: 'default',
}

